import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shareButtonText: {
    id: 'social.shareButton.text',
    defaultMessage: 'Produkt teilen',
  },
});
